export default __webpack_public_path__ + "locales/si/Article.json?hash=5b8701e9618e2bfb23638f4f7d6c601a";